// extracted by mini-css-extract-plugin
export default {"line-color":"#eee","lighter-background":"#eee"};